import React, { useEffect, useState } from "react";
import { ReactComponent as TrashIcon } from "../../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/EditBtn.svg";
import Button from "../../extra/Button";
import Pagination from "../../extra/Pagination";
import Table from "../../extra/Table";
import { connect, useDispatch, useSelector } from "react-redux";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import Searching from "../../extra/Searching";
import { warning } from "../../../util/Alert";
import UserImage from "../../../assets/images/8.jpg";
import coin from "../../../assets/images/mcoin.png";
import {
  getUser,
  isActiveUser,
  deleteUser,
} from "../../store/user/user.action";
import $, { get } from "jquery";
import ToggleSwitch from "../../extra/ToggleSwitch";
import LazyImage from "../../../common/ImageFallback";
import dayjs from "dayjs";
import UniqueIdCopy from "../../extra/UniqueIdCopy";

function ManageUser(props) {
  const { startDate, endDate, multiButtonSelectData } = props;
  const dispatch = useDispatch();
  const [age, setAge] = useState("");
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [actionPagination, setActionPagination] = useState("block");
  const [selectCheckData, setSelectCheckData] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [search, setSearch] = useState("");
  const { user, totalUser } = useSelector((state) => state.user);
  console.log("user", user);


  const isSubmitDisabled = !selectCheckData || selectCheckData.length === 0;
  const [data, setData] = useState();
  const [showURLs, setShowURLs] = useState([]);

  useEffect(() => {
    setData(user);
  }, [user]);
  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", UserImage);
    });
  });


  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleEdit = (row, type) => {

    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const handleSelectCheckData = (e, row) => {

    const checked = e.target.checked;
    if (checked) {
      setSelectCheckData((prevSelectedRows) => [...prevSelectedRows, row]);
    } else {
      setSelectCheckData((prevSelectedRows) =>
        prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id)
      );
    }
  };
  const handleSelectAll = (event) => {
    const checked = event.target.checked;

    setSelectAllChecked(checked);
    if (checked) {
      setSelectCheckData([...data]);
    } else {
      setSelectCheckData([]);
    }
  };

  const paginationSubmitButton = () => {

    const selectCheckDataGetId = selectCheckData?.map((item) => item?._id);
    const isActiveData = user.filter((user) => {
      return (
        user.isBlock === false &&
        selectCheckData.some((ele) => ele._id === user._id)
      );
    });
    const deActiveData = user.filter((user) => {
      return (
        user.isBlock === true &&
        selectCheckData.some((ele) => ele._id === user._id)
      );
    });

    const getId = isActiveData?.map((item) => item?._id);
    const getId_ = deActiveData?.map((item) => item?._id);
    if (actionPagination === "block" && selectCheckDataGetId?.length > 0) {
      const data = true;
      props.isActiveUser(getId, "user", data);
    } else if (actionPagination === "unblock") {
      const data = false;
      props.isActiveUser(getId_, "user", data);
    } else if (actionPagination === "delete") {
      const data = warning();
      data
        .then((res) => {
          if (res) {
            const yes = res.isConfirmed
            if (yes) {
              props.deleteUser(selectCheckDataGetId, "user");
            }
          }
        })
        .catch((err) => console.log(err));
    }
  };
  const ManageUserData = [
    {
      Header: "checkBox",
      width: "20px",
      Cell: ({ row }) => (
        <input
          type="checkbox"
          checked={selectCheckData.some(
            (selectedRow) => selectedRow?._id === row?._id
          )}
          onChange={(e) => handleSelectCheckData(e, row)}
        />
      ),
    },
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="  text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: "USER",
      body: "userName",
      Cell: ({ row, index }) => (
        <div className="d-flex align-items-center">
          <LazyImage
            imageSrc={row?.image ? row?.image : UserImage}
            width="50px"
            height="50px"
          />


          <div className="ms-3 ">
            {/* Nick Name */}
            <div className="fw-semibold text-start text-capitalize">
              {row?.fullName || "-"}
            </div>

            {/* Full Name */}
            <div className="text-muted small text-start text-capitalize">
              {row?.nickName || "-"}
            </div>
            <div className="text-muted small text-start text-capitalize">
              <UniqueIdCopy value={row?.uniqueId} placeholder="-" />
            </div>
          </div>
        </div>
      ),
    },
    // {
    //   Header: "ID",
    //   body: "id",
    //   Cell: ({ row }) => (
    //     <span className="text-capitalize    cursorPointer">
    //       {row?.uniqueId}
    //     </span>
    //   ),
    // },

    {
      Header: "EMAIL",
      body: "email",
      Cell: ({ row }) => (
        <span className="text-lowercase    cursorPointer">{row?.email}</span>
      ),
    },
    {
      Header: "COIN",
      body: "coin",
      Cell: ({ row }) => (
        <div className="d-flex align-items-center justify-content-center  gap-2">
          <img
            src={coin}
            alt="coin"
            style={{ width: "20px", height: "20px" }}
          />
          <span>{row?.coin || 0}</span>
        </div>
      ),
    },
    {
      Header: "PURCHASED COIN",
      body: "purchasedCoin",
      Cell: ({ row }) => (
        <div className="d-flex align-items-center justify-content-center  gap-2">
          <img
            src={coin}
            alt="coin"
            style={{ width: "20px", height: "20px" }}
          />
          <span>{row?.purchasedCoin || 0}</span>
        </div>
      ),
    },
    {
      Header: "TOTAL REWARD COIN",
      body: "totalRewardCoin",
      Cell: ({ row }) => (
        <div className="d-flex align-items-center justify-content-center  gap-2">
          <img
            src={coin}
            alt="coin"
            style={{ width: "20px", height: "20px" }}
          />
          <span>{row?.totalRewardCoin || 0}</span>
        </div>
      ),
    },
    {
      Header: "IP ADDRESS",
      body: "ipAddress",
      Cell: ({ row }) => (
        <span className="text-nowrap">{row?.ipAddress || "-"}</span>
      ),
    },
    {
      Header: "DEVICE ID",
      body: "deviceId",
      Cell: ({ row }) => (
        <span
          className="text-nowrap"
          style={{ maxWidth: "160px", display: "inline-block", overflow: "hidden", textOverflow: "ellipsis" }}
          title={row?.deviceId || ""}
        >
          {row?.deviceId || "-"}
        </span>
      ),
    },
    {
      Header: "DEVICE INFO",
      body: "deviceInfo",
      Cell: ({ row }) => {
        const info = row?.deviceInfo || {};
        const label = [info?.brand, info?.model].filter(Boolean).join(" ");
        const os = info?.osVersion
          ? `${(info?.platform || "").toLowerCase() === "ios" ? "iOS" : "Android"} ${info?.osVersion}`
          : "";
        return (
          <span className="text-nowrap">
            {label || "-"}
            {os ? (
              <span style={{ display: "block", fontSize: "11px", opacity: 0.7 }}>{os}</span>
            ) : null}
          </span>
        );
      },
    },
    {
      Header: "SAME DEVICE",
      body: "sameDeviceCount",
      Cell: ({ row }) => (
        <span
          className="text-nowrap"
          style={{ fontWeight: row?.sameDeviceCount > 1 ? "700" : "400", color: row?.sameDeviceCount >= 3 ? "#e03131" : "inherit" }}
        >
          {row?.sameDeviceCount ?? 0}
        </span>
      ),
    },
    {
      Header: "SAME IP",
      body: "sameIpCount",
      Cell: ({ row }) => (
        <span
          className="text-nowrap"
          style={{ fontWeight: row?.sameIpCount > 1 ? "700" : "400", color: row?.sameIpCount >= 3 ? "#e03131" : "inherit" }}
        >
          {row?.sameIpCount ?? 0}
        </span>
      ),
    },
    {
      Header: "REGISTERED",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-nowrap">
          {row?.createdAt ? dayjs(row?.createdAt).format("DD MMM YYYY, hh:mm A") : "-"}
        </span>
      ),
    },
    {
      Header: "LAST LOGIN",
      body: "lastLogin",
      Cell: ({ row }) => (
        <span className="text-nowrap">
          {row?.lastLogin ? dayjs(row?.lastLogin).format("DD MMM YYYY, hh:mm A") : "-"}
        </span>
      ),
    },
    {
      Header: "SUSPICIOUS",
      body: "isSuspicious",
      Cell: ({ row }) =>
        row?.isSuspicious ? (
          <span
            title={row?.suspiciousReason || ""}
            style={{ background: "#ffe3e3", color: "#e03131", padding: "3px 10px", borderRadius: "12px", fontSize: "12px", fontWeight: "600", whiteSpace: "nowrap" }}
          >
            Suspicious
          </span>
        ) : (
          <span style={{ color: "#2f9e44", fontSize: "12px", whiteSpace: "nowrap" }}>Clean</span>
        ),
    },
    {
      Header: "STATUS",
      body: "status",
      Cell: ({ row }) => <span>{row?.isBlock ? "Block" : "Unblock"}</span>,
    },
    {
      Header: "BLOCK",
      body: "isActive",
      Cell: ({ row }) => (
        <ToggleSwitch
          value={row?.isBlock}
          onChange={() => handleIsActive(row)}
        />
      ),
    }

  ];

  useEffect(() => {
    dispatch(getUser("realUser", page, size, startDate, endDate, search || ""));
  }, [dispatch, startDate, endDate, page, size, search]);

  const handleServerSearch = (value) => {
    setPage(1);
    setSearch(value || "");
  };

  const handleIsActive = (row) => {

    const id = row?._id;
    const data = row?.isBlock === false ? true : false;
    props.isActiveUser(id, "user", data);
  };

  const handleDeleteUser = (row) => {

    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed
          if (yes) {
            const id = row?._id;
            props.deleteUser(id, "user");
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  return (
    <div>
      <div className="user-table real-user mb-3">
        <div className="user-table-top">

          <h5
            style={{
              fontWeight: "500",
              fontSize: "20px",
              marginBottom: "5px",
              marginTop: "5px",
            }}
          >
            User
          </h5>
          <Searching
            // label={
            //   "Search for ID, Keyword, E-mail, Username, First Name, LastName"
            // }
            placeholder={"Search..."}
            type={"server"}
            serverSearching={handleServerSearch}
            setSearchData={setSearch}
            actionPaginationDataCustom={["Block", "Unblock"]}
            actionPagination={actionPagination}
            setActionPagination={setActionPagination}
            paginationSubmitButton={paginationSubmitButton}
            isSubmitDisabled={isSubmitDisabled}
          />
        </div>
        <div style={{ width: "100%", overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
          <Table
            data={data}
            mapData={ManageUserData}
            serverPerPage={size}
            serverPage={page}
            handleSelectAll={handleSelectAll}
            selectAllChecked={selectAllChecked}
            type={"server"}
          />
        </div>
        <Pagination
          type={"server"}
          activePage={page}
          rowsPerPage={size}
          userTotal={totalUser}
          setPage={setPage}
          handleRowsPerPage={handleRowsPerPage}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
}
export default connect(null, {
  getUser,
  isActiveUser,
  deleteUser,
})(ManageUser);
